import React                       from "react";
import cx                          from "classnames";
import PropTypes                   from "prop-types";
import {inject, observer}          from "mobx-react/index";
import { Switch, Route, Redirect } from "react-router-dom";
import Cookies                     from 'universal-cookie';

import stores from "../../stores/stores"; //app need it to load the mobx store

// creates a beautiful scrollbar
import "perfect-scrollbar/css/perfect-scrollbar.css";

// creates a beautiful scrollbar
import { withStyles } from "material-ui";


// core components
import Header  from "../../components/Header/Header.jsx";
import Footer  from "../../components/Footer/Footer.jsx";
import Sidebar from "../../components/Sidebar/Sidebar.jsx";


// material ui components
import CircularProgress from 'material-ui/Progress/CircularProgress';

import homeRoutes from "../../routes/home";


import appStyle from "../../assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";




import image from "../../assets/img/sidebar-2.jpg";
import logo  from "../../assets/img/logo-white.png";


import {
    DEFAULT_IMAGES,
} from "../../utils/constants";


import SweetAlert    from "react-bootstrap-sweetalert";
import {toJS}        from "mobx";
import ItemGrid      from "../../components/Grid/ItemGrid";
import GridContainer from "../../components/Grid/GridContainer";


@inject('store')
@observer
class App extends React.Component {

    constructor (props) {

        super(props);
        // console.log("A", dashboardRoutes);
        this.state = {
            mobileOpen: false,
            setMobileOpen: false,
            permitted:false,
            homeRoutes: homeRoutes,
            loading:true,
            maintenance_mode:false,
            miniActive: false,
            color: "rose",
            setColor: "blue",
            bgColor: "black",
            setBgColor: "black",
            setAlert: null,
            alert: false,
            alertTextMsg: ""
        };
        this.store = this.props.store.appState;
        this.permitted_users = false;
        this.permitted_users_shop = false;
        this.permitted_users_myshop = false;
        this.permitted_users_stack = false;
        this.permitted_users_coupon = false;

        this.permitted_stores = false;

        this.showAlert = this.showAlert.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
    }

    componentDidMount() {
        const cookies = new Cookies();
        this.handleLang(cookies.get('app_lang'));
        document.querySelector('body').scrollTop = 0;
    }

    handleLang = (lang) => {
        this.store.handle_app_lang(lang);
        // const DEFAULT_TEXT = import(`../../assets/translations/${lang}.json`).then((lang) => {
        import(`../../assets/translations/${lang}.json`).then((lang) => {
            this.setState({
                text: lang
            })
        }).catch((error) => {
            console.log('translations error = ',error);
            // console.error(`"${lang}" not yet supported`);
        });
    };

    handleDrawerToggle = () => {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    };

    sidebarMinimize = () => {
        // console.log("minimize");
        this.setState({ miniActive: !this.state.miniActive })
    };

    getRoute() {
        return this.props.location.pathname !== "/maps";
    };

    getAlert() {
        // console.log(this.state.alert);
        return this.state.alert;
    };


    showAlert(msg) {
        this.setState({alert: true, alertTextMsg: msg});
    }

    hideAlert(){
        this.setState({alert: false});
        this.store.logout();
    }


    isValidBrowser(){
        return true;
    }

    componentWillMount(){
        let self = this;
        // const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        const DEFAULT_TEXT = toJS(self.store.DEFAULT_TEXT);

        // self.setState({loading: false, maintenance_mode: false, alert: true});

        if(this.isValidBrowser()) {
            self.store.health_check(function(res) {
                if (res) {
                    if(self.store.token){
                        // console.log("1");
                        // console.log(self.store.token);
                        self.store.me({permissions: 1}, function (res) {
                            // console.log("3");
                            // console.log(res);

                            // NEW VERSION
                            if (res) {
                                // let menu_items_allowed = ['/dashboard', '/impostazioni', 'impostazioni/indirizzi', 'impostazioni/puntodiritiro', 'impostazioni/accessoimpostazionisicurezza', '/profilo', '/indirizz'];
                                // let menu_items_allowed = [];
                                // console.log("Role-Permissions", res.permissions);
                                // Se un utente non ha il permesso myaccount::access non può accedere (v.dopo per la logica dei permessi)

                                // res['permissions'].forEach(function (perm) {
                                //
                                //     if (perm.name === 'myaccount::access') {
                                //         self.permitted_users = true;
                                //         self.store.permitted_users = true;
                                //         self.setState({loading: false});
                                //     }
                                //
                                //     if(perm.name.toLowerCase().startsWith('myaccount')){
                                //
                                //         // myaccount::shop          //ordini shop
                                //         // myaccount::myshop        //link myshop + ordini myshop
                                //         // myaccount::stack         //abilita margins e royalties
                                //         // myaccount::coupon        //coupon
                                //
                                //
                                //         let slug = perm.name.split('::').pop();
                                //
                                //         if(slug === 'shop'){
                                //             let item = '/ordini-shop';
                                //             menu_items_allowed.push(item);
                                //             self.permitted_users_shop = true;
                                //             self.store.permitted_users_shop = true;
                                //         }
                                //
                                //         if(slug === 'myshop'){
                                //             let item = '/ordini-myshop';
                                //             let item_1 = '/myshop';
                                //             menu_items_allowed.push(item);
                                //             menu_items_allowed.push(item_1);
                                //             self.permitted_users_myshop = true;
                                //             self.store.permitted_users_myshop = true;
                                //         }
                                //
                                //         if(slug === 'stack'){
                                //             let item = '/margini-royalties';
                                //             menu_items_allowed.push(item);
                                //             self.permitted_users_stack = true;
                                //             self.store.permitted_users_stack = true;
                                //         }
                                //
                                //         if(slug === 'coupon'){
                                //             let item = '/coupon';
                                //             menu_items_allowed.push(item);
                                //             self.permitted_users_coupon = true;
                                //             self.store.permitted_users_coupon = true;
                                //         }
                                //     }
                                // });

                                if(!self.permitted_users ){
                                    // alert("L'utente non ha permessi sufficiente per accedere!!");
                                    // const msg = "L'utente non ha permessi sufficiente per accedere!!";

                                    self.setState({alert: true, alertTextMsg: DEFAULT_TEXT.myaccount_permission_alert, loading:false})
                                    // self.showAlert(msg);
                                    // self.store.logout();
                                    // return;
                                }

                                //Si verifica sulla “user_stores” se l’utente ha uno store associatos
                                // console.log("PROJECT_ID: ", self.store.project_id);

                                if(!self.store.project_id){
                                    self.setState({alert: true, alertTextMsg: DEFAULT_TEXT.myaccount_store_alert, loading:false})
                                    // self.store.logout();
                                    // return;
                                }
                            } else {
                                // console.log(res);
                            }
                        }, true);
                    }else{
                        self.setState({loading: false, maintenance_mode: false, alert: true});
                    }
                    // }
                } else {
                    self.setState({maintenance_mode:false, loading:false, alert: true});
                }
            });
        }else{
            alert("BROWSER NON SUPPORTATO, AGGIORNA IL TUO BROWSER O SCARICA L'ULTIMA VERSIONE DI GOOGLE CHROME");
        }
    }

    render() {

        const { classes, ...rest } = this.props;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

        const mainPanelClasses =
            classes.mainPanel +
            " " +
            cx({
                [classes.mainPanelSidebarMini]: this.state.miniActive,
                [classes.mainPanelWithPerfectScrollbar]: this.state.mobileOpen
            });

        const mainPanel = this.refs;

        /*
        const resizeFunction = () => {
            if (window.innerWidth >= 960) {
                this.setState({ setMobileOpen: !this.state.setMobileOpen });
            }
        };
        */


        // if(!this.store.token && !this.store.billing_form && !this.state.maintenance_mode && !this.state.loading){
        //     return <Redirect to='/login' />
        // }

        // console.log(this.store.token, this.state.maintenance_mode, this.state.loading);

        if(!this.store.token && !this.state.maintenance_mode && !this.state.loading){
            // console.log(this.store.token, this.state.maintenance_mode, this.state.loading);
            return <Redirect to='/login' />
        }


        const getActiveRoute = dashboardRoutes => {
            let activeRoute = "Default Brand Text";
            for (let i = 0; i < dashboardRoutes.length; i++) {
                if (dashboardRoutes[i].collapse) {
                    let collapseActiveRoute = getActiveRoute(dashboardRoutes[i].views);
                    if (collapseActiveRoute !== activeRoute) {
                        return collapseActiveRoute;
                    }
                } else {
                    if (
                        window.location.href.indexOf(dashboardRoutes[i].layout + dashboardRoutes[i].path) !== -1
                    ) {
                        return dashboardRoutes[i].name;
                    }
                }
            }
            return activeRoute;
        };


        const getRoutes = dashboardRoutes => {

            return dashboardRoutes.map((prop, key) => {

                if (prop.collapse) {
                    return getRoutes(prop.views);
                }

                prop.name = DEFAULT_TEXT[prop.label];

                if (prop.layout === "/photo-selfie") {
                    
                    return (
                        <Route path={prop.path} component={prop.component} key={key} />
                    );
                
                }else if(prop.redirect) {
                    
                    return <Redirect to={prop.to} />

                } else {
                    return null;
                    // return <Redirect to='/login' />
                }
            });
        };


        /*
        let switchRoutes = (
            <Switch>
                {
                    this.state.homeRoutes.map((prop, key) => {
                        if(prop.collapse){
                            // console.log(prop.views);
                            let collapseActiveRoute = prop.views;

                            for (let i = 0; i<collapseActiveRoute.length; i++){
                                return <Route path={collapseActiveRoute[i].path} component={collapseActiveRoute[i].component} key={key} />;
                            }
                            // return <Route path={prop.views.path} component={prop.views.component} key={key} />;
                        }
                        if (prop.redirect)
                            return <Redirect from={prop.path} to={prop.to} key={key} />;
                        return <Route path={prop.path} component={prop.component} key={key} />;
                    })
                }
            </Switch>
        );
        */


        const toDelete = new Set([false]);
        // const switchRoutesSidebar = this.state.dashboardRoutes.filter(obj => !toDelete.has(obj.invisible));
        const switchRoutesSidebar = this.state.homeRoutes.filter(obj => !toDelete.has(obj.invisible));


        return (
            this.state.loading && !this.state.maintenance_mode && this.state.alert ?
                (
                    //TODO Styling of ok button
                    // <div>
                    <GridContainer justify="center">
                        <ItemGrid xs={12} sm={6}>
                            <SweetAlert
                                error
                                style={{ display: "block", marginTop: "-100px" }}
                                title={DEFAULT_TEXT.myaccount_alert_title}
                                onConfirm={() => this.hideAlert()}
                                onCancel={() => this.hideAlert()}
                                confirmBtnCssClass={ this.props.classes.button + " " + this.props.classes.success}
                            >
                                {this.state.alertTextMsg}
                            </SweetAlert>
                        </ItemGrid>
                    </GridContainer>
                )
                :
                !this.state.loading && !this.state.maintenance_mode
                    ?
                    <div className={classes.wrapper}>
                        <Sidebar
                            routes={switchRoutesSidebar}
                            logoText={""}
                            logo={logo}
                            image={image}
                            handleDrawerToggle={this.handleDrawerToggle}
                            open={this.state.mobileOpen}
                            color={this.state.color}
                            bgColor={this.state.bgColor}
                            miniActive={this.state.miniActive}
                            {...rest}
                        />


                        <div className={mainPanelClasses} ref={mainPanel}>
                            <Header
                                routes={this.state.homeRoutes}
                                handleDrawerToggle={this.handleDrawerToggle}
                                sidebarMinimize={this.sidebarMinimize}
                                miniActive={this.state.miniActive}
                                {...rest}
                            />

                            {
                                this.getRoute()
                                    ?
                                    (
                                        <div className={classes.content}>
                                            <div className={classes.container}>
                                                <Switch>
                                                    {getRoutes(homeRoutes)}
                                                </Switch>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div className={classes.map}>
                                            <Switch>
                                                {getRoutes(homeRoutes)}
                                            </Switch>
                                        </div>
                                    )
                            }
                            { this.getRoute() ? <Footer /> : null }
                        </div>
                    </div>
                    :
                    !this.state.maintenance_mode
                        ?
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: "100vh"}}>
                            <CircularProgress className={classes.progress} style={{ color: "#e91e63", position:'fixed', zIndex:99, top:0, left:0, right:0, bottom:0, margin:'auto', width:100, height:100}}/>
                        </div>
                        :
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection:"column", height: "100vh"}}>
                            <img src={DEFAULT_IMAGES.logo} width={200} alt="logo"/>
                            <hr/>
                            <div>{DEFAULT_TEXT.maintenance_mode_title}</div>
                            <div>{DEFAULT_TEXT.maintenance_mode_description}</div>
                        </div>
        );
    }
}

App.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(appStyle)(App);



// WEBPACK FOOTER //
// ./src/layouts/Home/Home.jsx